import * as React from "react";
const SvgFiRrDoorOpen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-door-open_svg__a)">
      <path
        fill="#062147"
        d="M23 22h-3V6c0-2.206-1.794-4-4-4h-.535a4 4 0 0 0-.929-1.092 3.99 3.99 0 0 0-3.32-.829L8.019.72A5.01 5.01 0 0 0 4 5.62v16.38H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2M16 4c1.103 0 2 .897 2 2v16h-2zM6 5.621A3.01 3.01 0 0 1 8.411 2.68l3.196-.639a1.99 1.99 0 0 1 1.661.415c.465.381.731.944.731 1.546v18H6zm6 6.88a1.5 1.5 0 1 1-3.001-.002A1.5 1.5 0 0 1 12 12.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-door-open_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDoorOpen;
